import React from 'react';

const InvitedUser = ({user, index}) => {
  function getUserDisplayName(firstName, lastName) {
    return `${firstName} ${lastName}`;
  }

  function getRoleDisplayName(role) {
    switch (role) {
      case 'general':
        return `${capitalizeFirstLetter(role)} User`;
      case 'warehouse':
        return `${capitalizeFirstLetter(role)} Admin`;
      default:
        break;
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
      <tr>
        <td>{index}</td>
        <td>{getUserDisplayName(user.first_name, user.last_name)}</td>
        <td>{user.email}</td>
        <td>{getRoleDisplayName(user.role)}</td>
        <td>
          <ul className="action-icons">
            <li>
              <label className="switch">
                <input type="checkbox" disabled={true}/>
                <span className="slider round disabled"/>
              </label>
            </li>
            <li>
              <button type="button" className="delete-staff disabled" data-target=".delete-staff-modal"
                      data-toggle="modal"
                      disabled={true}>
                <i className="icon-delete"/>
              </button>
            </li>
          </ul>
        </td>
      </tr>
  );
};

export default InvitedUser;



// WEBPACK FOOTER //
// ./src/containers/Users/InvitedUser.jsx